import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { addressCharacters } from '@parchment/validation-utils';
import ComposedTextField from '../ComposedField/ComposedTextField';
export default function City(_ref) {
  let {
    name = 'city',
    label = 'City',
    autoComplete = 'address-level2',
    validators = [{
      message: 'Please enter a valid City',
      callback: addressCharacters
    }],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ComposedTextField, _extends({}, props, {
    name: name,
    label: label,
    autoComplete: autoComplete,
    validators: validators
  }));
}